import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import FooterBlockForm from '../../../components/siteadmin/FooterBlockForm';
import Loader from '../../../components/Loader';

import { withQuery } from '../../../hoc/withGraphql';

import s from './FooterBlock.css';

const FooterBlock = (props) => {

  const { data: { loading, getFooterSetting }, title } = props;
  if (loading) {
    return <Loader type={"text"} />;
  } else {
    const footerData = getFooterSetting ? {
      ...getFooterSetting,
      dynamicFooterBlock: getFooterSetting?.dynamicFooterBlock?.length > 0 ? getFooterSetting.dynamicFooterBlock : [{
        language: 'en',
        title1: getFooterSetting?.title1,
        content1: getFooterSetting?.content1,
        title2: getFooterSetting?.title2,
        content2: getFooterSetting?.content2,
        title3: getFooterSetting?.title3,
        content3: getFooterSetting?.content3,
      }]
    } : {};
    return <FooterBlockForm initialValues={footerData} title={title} />
  }
}

FooterBlock.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getFooterSettting: PropTypes.object,
  })
};

FooterBlock.defaultProps = {
  data: {
    loading: true,
    image: null
  }
};

export default compose(
  withStyles(s),
  withQuery(gql`
        {
            getFooterSetting {
                id
                title1
                content1
                title2
                content2
                title3
                content3
                dynamicFooterBlock {
                    language
                    title1
                    content1
                    title2
                    content2
                    title3
                    content3
                }
            }
        }
      `, {
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    }
  }),
)(FooterBlock);
